import { Fragment, memo } from 'react';
import EditData from './edit-data';
import CivilStatus from './civil-status';
import CivilUnion from './civil-union';
import CancelCivilUnion from './cancel-civil-union';
import AccordionPerson from 'shell/components/shared/person';

const FormCancelCivilUnionComponent = (): React.ReactElement => {
  return (
    <Fragment>
      <AccordionPerson disabled />
      <EditData />
      <CivilStatus
        disabled // fixed to "Stato libero a seguito di scioglimento dell'unione"
      />
      <CivilUnion />
      <CancelCivilUnion />
    </Fragment>
  );
};

FormCancelCivilUnionComponent.displayName = 'Cancel Marriage component';

const FormCancelCivilUnion = memo(FormCancelCivilUnionComponent);

export default FormCancelCivilUnion;
